import { useAppSelector } from "..";

export function useQdsSignaturesSelector() {
  return useAppSelector(({ qdsDocuments }) => qdsDocuments.qdsSignatures);
}

export function useFetchedQdsDocumentSelector() {
  return useAppSelector(({ qdsDocuments }) => qdsDocuments.fetchedQdsDocument);
}

export function useIsQdsSigningSelector() {
  return useAppSelector(({ qdsDocuments }) => qdsDocuments.isQdsSigning);
}

export function useQdsSplitPagesSelector() {
  return useAppSelector(({ qdsDocuments }) => qdsDocuments.qdsSplitPages);
}

export function useQdsDocumentIsSuccessfullySignedSelector() {
  return useAppSelector(({ qdsDocuments }) => qdsDocuments.qdsDocumentIsSuccessfullySigned);
}

export function useQdsDocumentBlobUrlSelector() {
  return useAppSelector(({ qdsDocuments }) => qdsDocuments.qdsDocumentBlobUrl);
}
